// import PropTypes from 'prop-types'
import BaseUIProductGroupListView from 'xui/modules/productGroup/BaseUIProductGroupListView'

export default class ProductGroupListView extends BaseUIProductGroupListView {}
